import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../ui/TextField";
import DataSelect from "../../../../../ui/DataSelect";
import { getOrganizations, getMunicipals } from "../../../../store/actions";
import { loadList } from "../../../../../Dict/Region/View/fetch";

const initialInfo = {
  name: "",
  organization: null,
  assign: "",
  region: -1,
  municipal: "2383",
  address: ""
};

const styles = () => ({
  rootForm:{
    marginTop: 24,
    '& .MuiGrid-spacing-xs-4 > .MuiGrid-item' : {
      paddingTop: 4,
      paddingBottom: 5
    }
  }
});

const FacilityEditInfoForm = ({
  classes,
  facilityInfo,
  getOrganizations,
  getMunicipals,
  organizations,
  municipals,
  disabled,
  onFormChange,
  loadList,
  regionsList = [],
  editmode
}) => {
  const initialData = facilityInfo || initialInfo;
  const [data, setData] = React.useState(initialData);
  const { latitude, longitude, ...dataWithNoCords } = data;
  const { name, organization, assign, region, municipal, address } = data;

  const onChange = (field, value) => {
    const newState = {
      ...dataWithNoCords,
      [field]: value
    };

    console.log("OnChange");
    setData(newState);
    onFormChange && onFormChange(newState);
  };

  React.useEffect(() => {
    getOrganizations();
    loadList();
  }, []);

  React.useEffect(() => {
    if (region) {
      getMunicipals(region);
    }
  }, [region]);

  return (
    <div className={classes.rootForm}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={name}
            onChange={e => onChange("name", e.target.value)}
            label="Название"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            value={assign}
            onChange={e => onChange("assign", e.target.value)}
            label="Назначение"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
        <Grid item xs={12}>
          <DataSelect
            value={organization}
            onChange={value => onChange("organization", value.id)}
            label="Организация"
            dataSource={organizations}
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataSelect
            value={region}
            onChange={value => onChange("region", value.id)}
            label="Регион"
            dataSource={regionsList}
            disabled={disabled || !editmode}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataSelect
            value={municipal}
            onChange={value => onChange("municipal", value.id)}
            label="Муниципальное образование"
            dataSource={municipals}
            disabled={disabled || !region || !editmode}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            value={address}
            onChange={e => onChange("address", e.target.value)}
            label="Адрес"
            disabled={disabled}
            readOnly={!editmode}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.facilities.isFetchingOrganizations,
  organizations: state.facilities.organizations,
  isFetchingMunicipals: state.facilities.isFetchingMunicipals,
  municipals: state.facilities.municipals,
  regionsList: state.dictRegionView.list
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getMunicipals: region => dispatch(getMunicipals(region)),
  loadList: () => dispatch(loadList())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FacilityEditInfoForm));
